if($('.gallery-img').length){
	$('.gallery-img').each(function(){
		var id = $(this).attr('data-video').match(/(^|=|\/)([0-9A-Za-z_-]{11})(\/|&|$|\?|#)/)[2];
		$(this).prepend('<img src="https://img.youtube.com/vi/'+id+'/hqdefault.jpg" alt="video thumbnail">');
	})
}

$('.gallery-img').on('click', function(e){
	$('#videoModal').modal('show');
	$('#videoModal iframe').attr('src',$(this).attr('data-video')+'?autoplay=1');
	$('#videoModal iframe').show();
	e.preventDefault();
});

$('#videoModal').on('hidden.bs.modal', function () {
	$('#videoModal iframe').attr('src','');
	$('#videoModal iframe').hide();
})


// WEBPACK FOOTER //
// ./scripts/includes/term-videos.js